export const LOADING_FACTOR_QUESTION = "LOADING_FACTOR_QUESTION";
export const SAVE_LOADING_FACTOR_QUESTION = "SAVE_LOADING_FACTOR_QUESTION";
export const GET_FACTOR_QUESTION = "GET_FACTOR_QUESTION";
export const FORM_FAIL = "FORM_FAIL";
export const FACTOR_QUESTION_FAIL = "FACTOR_QUESTION_FAIL";
export const LOADING_FACTOR_QUESTION_BY_ID = "LOADING_FACTOR_QUESTION_BY_ID";
export const GET_FACTOR_QUESTION_BY_ID = "GET_FACTOR_QUESTION_BY_ID";

